import React from 'react';
import { Text } from '@gbm-tech/typography';

import { InputContainer, InputGroupContainer } from './styles';

export type InputProps = React.ComponentPropsWithRef<'input'> & {
  full?: boolean;
  required?: boolean;
  inputSize?: 'sm' | 'md' | 'lg';
  inputWidth?: string;
};

export const Input: React.FC<InputProps> = ({
  full,
  required,
  inputSize,
  inputWidth = 'auto',
  ...props
}) => {
  return (
    <InputContainer
      full={full}
      required={required}
      inputSize={inputSize}
      css={{ $$inputWidth: inputWidth }}
      {...props}
    />
  );
};

export type InputGroupProps = React.ComponentPropsWithRef<'div'> & {
  full?: boolean;
  required?: boolean;
  label?: string;
  inputProps?: InputProps;
  width?: string;
};

export const InputGroup: React.FC<InputGroupProps> = ({
  full,
  inputProps,
  label,
  width = 'auto',
}) => {
  return (
    <InputGroupContainer full={full} css={{ $$inputWidth: width }}>
      <Text size="sm">{label && label}</Text>

      <Input full {...inputProps} />
    </InputGroupContainer>
  );
};
